import PageWrapper from '../../../pagecomponents/Common/PageWrapper';
import { Row, InputGroup, Button, Table } from 'react-bootstrap';
import { CCol, CFormLabel } from '@coreui/react';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getData } from '../../../redux/slices/MasterIncomeStatementSlice';
import { toastMessage, number_format } from '../../../helpers/utility';
import './style.css';
import ModalWrapper from '../../../pagecomponents/Common/ModalWrapper.js';
import BreakUpModal from './BreakUpModal.js';

const INIT_FORM_DATA = {
  start_date: format(new Date(new Date().setFullYear(new Date().getFullYear() - 1)), 'yyyy-MM-dd') + ' 00:00:00',
  end_date: format(new Date(), 'yyyy-MM-dd') + ' 23:59:59',
};

const IncomeStatement = () => {
  const pageName = 'Statement Of Comprehensive Income';
  const [formData, setFormData] = useState(INIT_FORM_DATA);
  const dispatch = useDispatch();
  const [searchedData, setSearchedData] = useState({});
  const [footerFlag, setFooterFlag] = useState(true);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalParam, setModalParam] = useState('');
  const [totalValue, setTotalValue] = useState(0);

  useEffect(() => {
    searchIncomeStatement();
  }, []);

  const searchIncomeStatement = async () => {
    const { payload } = await dispatch(getData({ inputData: formData }));
    if (payload?.status === 'error') {
      toastMessage('error', payload.msg || 'An error occurred while saving.');
    } else {
      setSearchedData(payload);
      console.log(payload);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date') {
      setFormData({
        ...formData,
        [name]: format(new Date(value), 'yyyy-MM-dd') + ' 00:00:00', // Format the date
      });
    } else if (name === 'end_date') {
      setFormData({
        ...formData,
        [name]: format(new Date(value), 'yyyy-MM-dd') + ' 23:59:59', // Format the date
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleAmountFormat = (amount) => {
    return number_format(amount, 2);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleBreakUp = (modalTitle, modalParam, total = null) => {
    console.log(modalTitle, modalParam, total, 'gvvfhthfccht');

    setModalVisible(true);
    setModalTitle(modalTitle);
    setModalParam(modalParam);
    setTotalValue(total);
  };

  return (
    <>
      <PageWrapper pageName={pageName}>
        <Row className="row-xs mb-4">
          <CCol md={3}>
            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="invoice_Date">
              From Date
            </CFormLabel>
            <InputGroup className="input-group reactdate-pic">
              <InputGroup.Text className="input-group-text">
                <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </InputGroup.Text>
              <DatePicker
                className="form-control"
                name="start_date"
                id="start_date"
                selected={formData.start_date ? new Date(formData.start_date) : null} // Convert to Date object
                onChange={(date) => {
                  const event = {
                    target: {
                      name: 'start_date',
                      value: date,
                    },
                  };
                  handleInputChange(event); // Simulate an event for compatibility
                }}
                dateFormat="yyyy-MM-dd" // Match the desired format
                // isClearable // Optional: Allow clearing the date
              />
            </InputGroup>
          </CCol>
          <CCol md={3}>
            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="end_date">
              To Date
            </CFormLabel>
            <InputGroup className="input-group reactdate-pic">
              <InputGroup.Text className="input-group-text">
                <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </InputGroup.Text>
              <DatePicker
                className="form-control"
                name="end_date"
                id="end_date"
                selected={formData.end_date ? new Date(formData.end_date) : null} // Convert to Date object
                onChange={(date) => {
                  const event = {
                    target: {
                      name: 'end_date',
                      value: date,
                    },
                  };
                  handleInputChange(event); // Simulate an event for compatibility
                }}
                dateFormat="yyyy-MM-dd" // Match the desired format
                // isClearable // Optional: Allow clearing the date
              />
            </InputGroup>
          </CCol>
          <CCol
            md={3}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              paddingTop: '28px',
            }}
          >
            <Row className="btn-animation">
              <Button
                variant=""
                type="button"
                className={`btn btn-sm btn-primary ms-2`}
                onClick={() => {
                  searchIncomeStatement();
                }}
              >
                Get Data
              </Button>
            </Row>
          </CCol>
          <CCol
            md={3}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              paddingTop: '28px',
            }}
          >
            <Row className="btn-animation">
              <Button
                variant=""
                type="button"
                className={`btn btn-sm btn-primary`}
                onClick={() => {
                  window.print(); // TODO: Buttons should not be visible on print
                }}
              >
                Print
              </Button>
            </Row>
          </CCol>
        </Row>
        {Object.keys(searchedData).length > 0 ? (
          <Table className="text-nowrap mb-0">
            <thead>
              <tr className="border-bottom border-top">
                <th className="w-75">Particulars</th>
                <th className="text-right">Collection</th>
                <th className="text-right">Totals</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pb-0">Total Sales</td>
                <td className="pb-0 text-right">
                  {handleAmountFormat(searchedData.revenue)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() => handleBreakUp('Revenue', 'revenue', searchedData.revenue)}
                  ></i>
                </td>
                <td className="pb-0 text-right"></td>
              </tr>
              <tr>
                <td className="py-0 ">Total Cost of Sales</td>
                <td className="py-0 text-right border-bottom">
                  {handleAmountFormat(searchedData.cost_of_rev)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() => handleBreakUp('Cost of Revenue', 'Cost of Revenue', searchedData.cost_of_rev)}
                  ></i>
                </td>
                <td></td>
              </tr>
              <tr>
                <td className="font-weight-bold">Gross Profit</td>
                <td></td>
                <td className="text-right font-weight-bold">{handleAmountFormat(searchedData.gross_profit)}</td>
              </tr>
              <tr>
                <td className="text-left">Add: Other Incomes</td>
                <td></td>
                <td className="text-right border-bottom">
                  {handleAmountFormat(searchedData.other_Income)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() => handleBreakUp('Other Incomes', 'Other Incomes', searchedData.other_Income)}
                  ></i>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td className="text-right">{handleAmountFormat(searchedData.gp_oi)}</td>
              </tr>
              <tr>
                <td className="text-left font-weight-bold">Less: Expenses</td>
                <td></td>
                <td></td>
              </tr>

              <tr>
                <td className="pb-0">Administrative Expense</td>

                <td className="pb-0 text-right">
                  {handleAmountFormat(searchedData.admin_expences)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() =>
                      handleBreakUp('Administrative Expense', 'administration_expences', searchedData.admin_expences)
                    }
                  ></i>
                </td>
                <td></td>
              </tr>
              <tr>
                <td className="py-0">Depreciation</td>

                <td className="py-0 text-right">
                  {handleAmountFormat(searchedData.depriciation)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() => handleBreakUp('Depreciation', 'depreciation', searchedData.depriciation)}
                  ></i>
                </td>
                <td></td>
              </tr>
              <tr>
                <td className="py-0">Journal Voucher</td>

                <td className="py-0 text-right">
                  {handleAmountFormat(searchedData.journal)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() => handleBreakUp('Journal', 'journal', searchedData.journal)}
                  ></i>
                </td>
                <td></td>
              </tr>
              <tr>
                <td className="py-0">Finance Charges</td>

                <td className="py-0 text-right border-bottom">
                  {handleAmountFormat(searchedData.finance)}
                  <i
                    className="fe fe-info cursor-pointer pd-4"
                    onClick={() => handleBreakUp('Finance Charges', 'finance_expences', searchedData.finance)}
                  ></i>
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td className="py-0 text-right">{handleAmountFormat(searchedData.total_expence)}</td>
              </tr>
              <tr className="border-bottom border-top">
                <td className="text-left font-weight-bold">Net Profit:</td>
                <td></td>
                <td className="text-right font-weight-bold">{handleAmountFormat(searchedData.net_profit)}</td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <></>
        )}
      </PageWrapper>

      <ModalWrapper
        visible={modalVisible}
        onClose={() => closeModal()}
        modalTitle={modalTitle}
        modalSize={'lg'}
        footerFlag={footerFlag}
        footerBody={
          <div className="d-flex justify-content-between w-100">
            <span className="fw-bold">Total:</span>
            <span>{handleAmountFormat(totalValue)}</span>
          </div>
        }
      >
        <BreakUpModal
          type={modalParam}
          start_date={formData.start_date}
          end_date={formData.end_date}
          setFooterFlag={setFooterFlag}
        />
      </ModalWrapper>
    </>
  );
};

export default IncomeStatement;
